import React, { useState, useEffect } from "react";
import { FaHome, FaFolder, FaFileAlt, FaSignOutAlt, FaUser } from "react-icons/fa";
import "./projet.css";
import logo from "../../../assets/irc-logo-rb.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../shared/Sidebar";

const Projet = () => {
  const [competitionsData, setCompetitionsData] = useState([]);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState("competition");
  const [currentPage, setCurrentPage] = useState(1);
  const [competitionsPerPage] = useState(5);
  const [profileComplete, setProfileComplete] = useState(true); 
  const navigate = useNavigate();

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    axios
      .get(`${baseUrl}/getCompitition.php`)
      .then((response) => {
        console.log("Competitions data:", response.data); // Log the data to ensure it's being fetched
        setCompetitionsData(response.data);
      })
      .catch((error) => console.error("Error fetching competitions:", error));
  }, []);

  useEffect(() => {
    const checkProfile = async () => {
      try {
        const baseUrl = process.env.REACT_APP_BASE_URL;
        // Get idchercheur from cookies
        const getCookie = (name) => {
          const value = `; ${document.cookie}`;
          const parts = value.split(`; ${name}=`);
          if (parts.length === 2) return parts.pop().split(';').shift();
          return null;
        };
        const userId = getCookie("idchercheur");
        if (!userId) {
          setProfileComplete(false);
          return;
        }
        const response = await axios.get(`${baseUrl}/checkProfile.php?user_id=${userId}`);
        if (response.data && typeof response.data.complete !== 'undefined') {
          setProfileComplete(response.data.complete);
        } else {
          setProfileComplete(false);
        }
      } catch (error) {
        setProfileComplete(false); // If error, assume incomplete
      }
    };
    checkProfile();
  }, []);

  useEffect(() => {
    const idchercheur = document.cookie.split('; ').find(row => row.startsWith('idchercheur='));
    if (!idchercheur) {
      navigate("/login", { replace: true });
    }
  }, []);

  const handleToggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const handleItemClick = (item) => {
    setSelectedItem(item);
  };

  const handleApplyClick = async (input) => {
    const selectedCompetition =
      typeof input === "object"
        ? input
        : competitionsData.find((c) => c.idcompetition === input);

    if (!selectedCompetition) {
      console.error("Competition not found!");
      return;
    }

    console.log("Selected Competition Object:", selectedCompetition); // Debugging log
    console.log("Selected Competition ID:", selectedCompetition.idcompetition); // Debugging log

    try {
      const baseUrl = process.env.REACT_APP_BASE_URL;
      const response = await axios.get(
        `${baseUrl}/projets.php?action=getLastProjectId`
      );

      if (response.data.status === "success") {
        const lastProjectId = Number(response.data.data.lastProjectId) || 0;
        const newProjectId = lastProjectId + 1;

        // Pass idcompetition to the next page
        navigate("/Forum_ProjectChercheur", {
          state: {
            budgetParametreId: selectedCompetition.ID_budget_parametre,
            projectId: newProjectId,
            idcompetition: selectedCompetition.idcompetition, // Ensure idcompetition is passed
            date_fin: selectedCompetition.date_fin,
          },
        });
      } else {
        alert("Failed to fetch the last project ID: " + response.data.message);
      }
    } catch (error) {
      console.error("Error fetching the last project ID:", error);
      alert("There was an error fetching the last project ID!");
    }
  };

  // Filter only competitions that are online and not expired
  const today = new Date();
  const filteredCompetitions = competitionsData.filter((competition) => {
    const endDate = new Date(competition.date_fin);
    return competition.enligne === "1" && endDate >= today;
  });

  // Calculate indices for pagination
  const indexOfLastCompetition = currentPage * competitionsPerPage;
  const indexOfFirstCompetition = indexOfLastCompetition - competitionsPerPage;
  const currentCompetitions = filteredCompetitions.slice(
    indexOfFirstCompetition,
    indexOfLastCompetition
  );

  // Calculate total pages based on filtered competitions
  const totalPages = Math.ceil(
    filteredCompetitions.length / competitionsPerPage
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className={`projet-container ${isSidebarOpen ? "sidebar-open" : ""}`}>
      <Sidebar onHomeClick={handleToggleSidebar} />
      <div className="content">
        {!profileComplete && (
          <div
            className="profile-warning"
            style={{
              background: "#fff3cd",
              color: "#856404",
              padding: "16px",
              borderRadius: "8px",
              marginBottom: "18px",
              border: "1px solid #ffeeba",
              fontWeight: "500",
              textAlign: "center",
            }}
          >
            Votre profil n'est pas complet. Veuillez compléter{" "}
            <span
              style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}
              onClick={() => navigate("/Mon-compte")}
            >
              votre profil
            </span>{" "}
            pour accéder à toutes les fonctionnalités.
          </div>
        )}
        {selectedItem === "competition" && (
          <div className="competition-container">
            {currentCompetitions.map((competitions) => (
              <div
                className="competition-card"
                key={competitions.idcompetition}
              >
                <h3 className="card-title">{competitions.titre}</h3>
                <p>
                  <strong>Libellé:</strong> {competitions.libelle}
                </p>
                <p>
                  <strong>Date de début:</strong> {competitions.date_debut}
                </p>
                <p>
                  <strong>Date de fin:</strong> {competitions.date_fin}
                </p>
                <p>
                  <strong>Année de compétition:</strong>{" "}
                  {competitions.annee_competition}
                </p>
                <div className="action">
                  {competitions.enligne === "1" ? (
                    <button
                      className="apply-button"
                      onClick={() => handleApplyClick(competitions.idcompetition)}
                      disabled={!profileComplete}
                      style={
                        !profileComplete
                          ? { background: "#ccc", color: "#888", cursor: "not-allowed", border: "1px solid #ccc" }
                          : {}
                      }
                    >
                      Appliquer
                    </button>
                  ) : (
                    <span className="unavailable">Non disponible</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
        {totalPages > 1 && (
          <div className="pagination-container">
            <ul className="pagination">
              {Array.from({ length: totalPages }, (_, i) => (
                <li
                  key={i}
                  className={`page-item ${
                    currentPage === i + 1 ? "active" : ""
                  }`}
                >
                  <button onClick={() => paginate(i + 1)} className="page-link">
                    {i + 1}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default Projet;
